import { useReport } from './hooks/use-context';

export function Members() {
  const { body, header } = useReport();

  const infoSection = body?.sections?.find(
    (section) => section.section_name === 'Informações',
  );

  const participantQuestionNames = [
    'Nome do participante:',
    'Nome do Participante (s):',
    'Participantes:',
  ];

  const participantAnswers =
    infoSection?.questions
      .filter((question) => participantQuestionNames.includes(question.name))
      .flatMap((question) => question.answers) || [];

  const firstParticipant = participantAnswers[0];
  const secondParticipant = participantAnswers[1];

  // Busca por ID para o PDF "Inspeção - Caminhão Guindaste e Munck"
  const participantNameById =
    infoSection?.questions.find(
      (question) => question.question_id === 'e64db6ff-fb40-4961-ba1e-2492f2739883',
    )?.answers[0]?.content || '';

  const participantRoleById =
    infoSection?.questions.find(
      (question) => question.question_id === 'c29f6504-487d-48d2-a863-740774ffb084',
    )?.answers[0]?.content || '';

  const responsibleManagerById =
    infoSection?.questions.find(
      (question) => question.question_id === '5c774d22-76e5-4801-8204-7c7bdcf93b63',
    )?.answers[0]?.content || '';

  const participantRole =
    infoSection?.questions.find(
      (question) => question.name === 'Cargo do participante:',
    )?.answers[0]?.content || '';

  const responsibleManagerName =
    infoSection?.questions.find(
      (question) => question.name === 'Nome do gestor responsável:',
    )?.answers[0]?.content || '';

  return (
    <div style={{ fontSize: '10px', breakInside: 'avoid' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '5fr 8fr 5fr 12fr',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'repeat(3, 1fr)',
          }}
        >
          <div
            style={{
              gridRow: '1 / span 3',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '0px 5px',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            Participantes
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            Nome
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div>{firstParticipant?.content || participantNameById}</div>
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div>{secondParticipant?.content}</div>
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            Cargo/Função
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div>
              {firstParticipant?.collection_item?.properties?.find(
                (property) => property.name === 'CARGO',
              )?.content ||
                participantRoleById ||
                participantRole}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div>
              {secondParticipant?.collection_item?.properties?.find(
                (property) => property.name === 'CARGO',
              )?.content}
            </div>
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderBottom: '1.1px #000 solid',
            }}
          >
            Gestor Responsável
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>Nome:</div>
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {firstParticipant?.collection_item?.properties?.find(
                (property) => property.name === 'GESTOR',
              )?.content ||
                responsibleManagerById ||
                responsibleManagerName}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              borderBottom: '1.1px #000 solid',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>Data:</div>
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {header?.event_created_at}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '5fr 25fr',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              backgroundColor: '#fff',
              fontWeight: 'bold',
              padding: '0px 2px',
              borderRight: '1.1px #000 solid',
              borderBottom: '1.1px #000 solid',
            }}
          >
            Responsável pela área
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '4px',
            borderBottom: '1.1px #000 solid',
          }}
        >
          <div>
            {
              infoSection?.questions.find(
                (question) => question.name === 'Nome do responsável da área:',
              )?.answers[0]?.content
            }
          </div>
        </div>
      </div>
    </div>
  );
}
